import React from 'react';
import { useDispatch } from 'react-redux';
import { Form } from 'react-final-form';

import validate from '../../../utils/validate';
import { createGenieGoProjectYupValidation } from '../validation';
import { createGenieGoProject } from '../../../redux/projects/projectsActions';
import GenieGoCreationForm from './GenieGoCreationForm';

function GenieGoCreation() {
  const dispatch = useDispatch();

  const createScoutProjectInitialValues = {
    projectName: '',
    brand: '',
    assignUser: '',
    activeUsers: [],

    activeAllAssistants: [],
    description: '',
    referenceMessages: '',
  };

  const handleCreateProject = (values) => {
    dispatch(createGenieGoProject(values));
  };

  return (
    <Form
      initialValues={createScoutProjectInitialValues}
      onSubmit={handleCreateProject}
      validate={(values) => validate(values, createGenieGoProjectYupValidation())}
      subscription={{ submitting: true, pristine: true }}
      render={({ handleSubmit }) => <GenieGoCreationForm handleSubmit={handleSubmit} />}
    />
  );
}

export default GenieGoCreation;
